import React, { CSSProperties } from 'react';

import * as messages from '@radnuc/messages';

import { queryN42, queryPdf } from './Query';
import { t } from 'i18next';
import './i18n';

import './ShareButtonDisplay.css'

import share_logo from './img/share4-32.png'
import share_white_logo from './img/share4-32-white.png'
import green_check_logo from './img/check_alt-green-32.png'
import red_x_logo from './img/x_alt-red-32.png'
import { uuidToString } from './UUID';

type Investigation = messages.Encounter.Encounter | messages.Rad.Investigation;

export interface ShareButtonDisplayProps {
    investigation: Investigation;
    linked_dialog_showing: boolean | null;
    style: CSSProperties | undefined;
    showPdfExport?: boolean | undefined;
}

export interface ShareButtonDisplayState {
    share_dropdown_show: boolean | null;
    share_success_state: number;
}

export class ShareButtonDisplay extends React.Component<ShareButtonDisplayProps, ShareButtonDisplayState, {}> {
    timeoutTimer: NodeJS.Timeout | null;

    constructor(props: ShareButtonDisplayProps) {
        super(props)
        this.state = { share_dropdown_show: false, share_success_state: 0 }
        this.timeoutTimer = null;

        this.handleExportN42Click = this.handleExportN42Click.bind(this);
        this.handleExportPDFClick = this.handleExportPDFClick.bind(this);
        this.handleShareClick = this.handleShareClick.bind(this);
    }

    displayShareSuccess() {
        this.setState(state => ({
            share_success_state: 1
        }));
        if (this.timeoutTimer != null)
            clearTimeout(this.timeoutTimer);
        this.timeoutTimer = setTimeout(state => {
            this.setState(state => ({
                share_success_state: 0
            }));
            this.timeoutTimer = null;
        }, 3000);
    }

    displayShareFail() {
        this.setState(state => ({
            share_success_state: 2
        }));
        if (this.timeoutTimer != null)
            clearTimeout(this.timeoutTimer);
        this.timeoutTimer = setTimeout(state => {
            this.setState(state => ({
                share_success_state: 0
            }));
            this.timeoutTimer = null;
        }, 3000);
    }

    handleShareClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.setState(state => ({
            share_dropdown_show: !state.share_dropdown_show
        }));

        if (this.timeoutTimer != null)
            clearTimeout(this.timeoutTimer);
        if (!this.state.share_dropdown_show) {
            this.timeoutTimer = setTimeout(state => {
                this.setState(state => ({
                    share_dropdown_show: false
                }));
                this.timeoutTimer = null;
            }, 5000);

        }
    }

    handleExportN42Click(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.setState(state => ({
            share_dropdown_show: false
        }));

        const d = new Date(this.props.investigation.start_time);
        const datestring = d.toLocaleString("en-us", {month: "short"})+'_'+d.getDate()+'_'+d.getFullYear();
        const timestring = d.toLocaleString('en-US', {hour:'numeric',minute:'numeric',second:'numeric',hour12: true }).replace(/:/g,"_").replace(" ","_");
        const n42_filename = "n42_"+datestring+"_"+timestring+'.xml';
        queryN42(this.props.investigation.id).then(result => {
            let element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(result));
            element.setAttribute('download', n42_filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
            this.displayShareSuccess()

        }).catch(err => {
            this.displayShareFail();
        });
    }

    handleExportPDFClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.setState(state => ({
            share_dropdown_show: false
        }));

        const d = new Date(this.props.investigation.start_time);
        const datestring = d.toLocaleString("en-us", {month: "short"})+'_'+d.getDate()+'_'+d.getFullYear();
        const timestring = d.toLocaleString('en-US', {hour:'numeric',minute:'numeric',second:'numeric',hour12: true }).replace(/:/g,"_").replace(" ","_");
        const pdf_filename = "Inv_"+datestring+"_"+timestring+'.pdf';
        queryPdf(this.props.investigation.id,30000).then(result => {

            console.log(result)
            if (result.type !== "application/octet-stream"){
                throw new Error('Failed in PDF Export');
            }

            let element = document.createElement('a');
            let url = window.URL.createObjectURL(result)
            element.setAttribute('href',url);
            element.setAttribute('download', pdf_filename);
            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
            this.displayShareSuccess()

        }).catch(err => {
            this.displayShareFail();
        });
    }

    componentDidUpdate() {
        if (this.props.linked_dialog_showing && this.state.share_dropdown_show) {
            this.setState(state => ({
                share_dropdown_show: false
            }));
        }
    }

    componentWillUnmount() {
        if (this.timeoutTimer !== null) {
            clearTimeout(this.timeoutTimer);
        }
    }

    render() {
        //Buttons
        let pdf_export_visibility:'visible'|'hidden'|undefined;
        if(this.props.showPdfExport !== undefined){
            pdf_export_visibility = this.props.showPdfExport ? 'visible' : 'hidden';
        } else {
            pdf_export_visibility = 'visible';
        }

        let drowpdownMenuItems;
        if('type' in this.props.investigation){
            if(this.props.investigation.type === messages.Encounter.EncounterType.RAD){
                drowpdownMenuItems =
                    <>
                        <div className="inv-menu-item" onClick={this.handleExportN42Click}>{t('N42 With Context',{ns:'trans'})}</div>
                        <div className="inv-menu-item" onClick={this.handleExportPDFClick} style={{ visibility: pdf_export_visibility }}>{t('PDF Summary',{ns:'trans'})}</div>
                        <div className="inv-menu-item" style={{ visibility: 'hidden' }}>N42 No Context</div>
                    </>
            } else if(this.props.investigation.type === messages.Encounter.EncounterType.CHEM){
                //Export options for CHEM Inv
            } else if(this.props.investigation.type === messages.Encounter.EncounterType.BIO){
                //Export options for BIO Inv
            }
        } else {
            drowpdownMenuItems =
                <>
                    <div className="inv-menu-item" onClick={this.handleExportN42Click}>N42 With Context</div>
                    <div className="inv-menu-item" onClick={this.handleExportPDFClick} style={{ visibility: pdf_export_visibility }}>{t('PDF Summary',{ns:'trans'})}</div>
                    <div className="inv-menu-item" style={{ visibility: 'hidden' }}>N42 No Context</div>
                </>
        }

        let share_dropdown;
        if (!this.props.linked_dialog_showing && this.state.share_dropdown_show) {
            share_dropdown =
                <div className="inv-share-dropdown-container inv-menu-item" style={{ display: 'flex', position: 'absolute' }}>
                    <div className="plot-title dropdown share-dropdown-surrogate"></div>
                    <div id="share-select-dropdown-content" className="dropdown-content share-dropdown show" style={this.props.style}>
                        <div className="plot-header" style={{ background: 'orange' }}>
                            <label className="plot-title " style={{ color: 'black', fontSize: '1em' }}>{t('Export Investigation',{ns:'trans'})}</label>
                        </div>
                        {drowpdownMenuItems}
                    </div>
                </div>
        }

        let share_status;
        if (this.state.share_success_state === 1) {
            share_status =
                <img src={green_check_logo} alt="Success" className="inv-share-success inv-menu-button" style={{ cursor: 'pointer' }}></img>
        } else if (this.state.share_success_state === 2) {
            share_status =
                <img src={red_x_logo} alt="Fail" className="inv-share-fail inv-menu-button" style={{ cursor: 'pointer' }}></img>
        } else {
            if (this.state.share_dropdown_show) {
                share_status =
                    <img src={share_white_logo} alt="Share" className="inv-share-open inv-menu-button dropdownevent plot-title dropdown" id="share-select-dropdown" style={{ cursor: 'pointer' }} onClick={this.handleShareClick}></img>
            } else {
                share_status =
                    <img src={share_logo} alt="Share" className="inv-share inv-menu-button dropdownevent plot-title dropdown" id="share-select-dropdown" style={{ cursor: 'pointer' }} onClick={this.handleShareClick}></img>
            }
        }

        let share_button =
            <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                <div id="share-select-dropdown" className="dropdown" style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                    {share_dropdown}
                    <div className="inv-share-container inv-menu-item">
                        {share_status}
                    </div>
                    <div className="inv-export-all-hidden" style={{ display: 'none'}} onClick={this.handleExportN42Click}/>
                </div>
            </div>


        return (share_button);
    }
}
export default ShareButtonDisplay
